<template>
  <span :class="dateClass">{{ dateLabel }}</span>
</template>

<script>
const THRESHOLD_DAYS = 30;

export default {
  props: ["item"],
  computed: {
    next() {
      return this.item.nextProofDate;
    },
    daysLeft() {
      if (!this.next) return null;
      return (new Date(this.next).getTime() - Date.now()) / (1000 * 60 * 60 * 24);
    },
    dateClass() {
      if (!this.next) return "error--text font-weight-medium";
      if (this.daysLeft < 0) return "error--text font-weight-medium";
      if (this.daysLeft <= THRESHOLD_DAYS) return "warning--text font-weight-medium";
      return "success--text";
    },
    dateLabel() {
      if (!this.next) return this.$t("proof.noDate");
      return new Date(this.next).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
    },
  },
};
</script>
